import usePurchase from '@hooks/analytics/usePurchase';
import { useFlow } from '@stackflow/react';
import { setIsPrepaidCardBalanceUpdated } from '@utils/prepaidCardUtils';
import { getTempOrder } from '@utils/restoreOrderUtils';
import { useEffect } from 'react';

function useOrderComplete(orderNo: string) {
    const { replace, push } = useFlow();
    const sendPurchase = usePurchase();
    const handleCookies = async () => {
        try {
            const tempOrder = await getTempOrder('ORDER');
            await sendPurchase(orderNo, tempOrder);
            const isUsePrepaidCard = (tempOrder?.prepaidCardPayments?.length || 0) > 0;
            if (isUsePrepaidCard) {
                setIsPrepaidCardBalanceUpdated(true);
            }
        } catch {
            console.log('clean up order failed');
        }
    };
    useEffect(() => {
        handleCookies();
        replace('MainActivity', {}, { animate: false });
        push('OrderLogsActivity', { duration: 'ALL' }, { animate: false });
        push('OrderLogActivity', { orderNo });
    }, [orderNo]);
}

export default useOrderComplete;
